/* Geometry constants for the scoreline glyph. Split out of ScorelineIcon.tsx
   only because that file may export nothing but the component itself
   (react-refresh/only-export-components). */

export const SCORELINE_VIEWBOX = 24
export const SCORELINE_STROKE = 2.4
/** Rendered size (px) of this glyph in the bottom nav. Exported so the
 * component's default `size` and the CSS override in BottomNav.css agree —
 * otherwise the svg's width/height attributes would paint one size for a
 * frame before the stylesheet resized it. */
export const SCORELINE_NAV_SIZE = 33

/** Stroke width in viewBox units that renders as SCORELINE_STROKE *device* px at
 * `size`. Same idea as lucide's `absoluteStrokeWidth`: this glyph is rendered
 * larger than its neighbours for optical reasons (see BottomNav.css), and
 * letting the viewBox scale carry the stroke along with it would push the
 * rendered weight past 2.4 and read clumsy next to the lucide icons beside it
 * (which index.css renders at stroke-width 1.7 — this glyph is sparse enough
 * that 2.4 still balances them, but not by much). */
export function scorelineStrokeWidth(size: number) {
  return (SCORELINE_STROKE * SCORELINE_VIEWBOX) / size
}
